import Vue from 'vue';
import { PhoneNumber } from '@/types/global';

export function formatPhoneNumber(phoneNumber: PhoneNumber): string {
  return `+${phoneNumber.countryCode} ${phoneNumber.phoneNumber}`;
}

Vue.filter('formatPhoneNumber', formatPhoneNumber);
